// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Career Page Styles */

/* Hero Section */
.scl--web-page-career-hero-section {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  max-height: 1212px;
  background: #000000;
  position: relative;
  overflow: hidden;
}

.scl--web-page-career-hero-section .scl--wpchs-cont-stl-bo .scl--web-component-hero-content button{
  background: transparent;
  border: 1.5px solid rgba(121, 121, 121, 1)
}

.scl--web-page-career-hero-section .scl--wpchs-cont-stl-bo .scl--web-component-hero-content button:hover{
  background: #FFFFFF1A;
  border: 1px solid white;
}

.scl--wpchs-cont-stl-bo{
  position: absolute;
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right);
  z-index: 51;
}

.scl--web-page-career-gradient-overlay {
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  height: 100%;
  background: #000000;
  z-index: 1;
}

/* Join Us Section */
.scl--web-page-career-join-us-section {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 788px;
  background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);
}

.scl--wpcjus-section-job-seek{
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right);
  display: flex;
  flex-direction:row;
}

.scl--web-page-career-join-us-title-side {
  height: 100%;
  width: 400px;
  padding-top: 90px;

}

.scl--web-page-career-join-us-section-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 80px;
  width: 100%;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.scl--web-page-career-join-us-section-title .scl--web-component-section-title-text{
  font-size: var(--font-size-sub-title-xl);
  line-height: 60px;
  font-weight: 500;
}

.scl--web-page-career-view-all-button {
  min-width: 183px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 5px;
  height: 40px;
  border: 1.5px solid #797979;
  border-radius: 20px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin-top: 15px;
}

.scl--web-page-career-join-us-job-list-side {
  height: 100%;
  width: calc(100% - 400px);
  padding-top: 175px;
  padding-left: 90px;
  padding-bottom: 85px;
  box-sizing: border-box;
}

.scl--web-page-career-join-us-job-list-side.active{
  padding: 0px;
}

/* Our Talent Section */
.scl--web-page-career-our-talent-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px ;
  background-color: rgba(0, 0, 0, 1);
  position: relative;
  width: 100%;
}

.scl--web-page-career-our-talent-content {
  width: 100%;
  max-width: var(--global-desktop-width-resp);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
  padding-left: var(--global-desktop-padding-left);
  padding-right: var(--global-desktop-padding-right);
}

.scl--web-page-career-our-talent-section-title {
  text-align: center;
  align-items: center;
}

.scl--web-page-career-our-talent-content .scl--web-component-section-title-container{
  gap: 0px;
}

/* Footer Section */
.scl--web-page-career-footer-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 140px;
  background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);
  position: relative;
  overflow: hidden;
  min-height: 200px;
}

.scl--web-page-career-footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  z-index: 2;
}

.scl--web-page-career-icon-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
}

.scl--web-page-career-copyright-text {
  font-family: 'SF Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: #8C8C8C;
  margin: 0;
}

.scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container{
  margin-top: 80px;
}

.scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container h2{
  font-size: var(--font-size-sub-title-xl);
  font-weight: 500;
}

.scl--web-page-career-our-talent-content .scl--web-component-talent-list-container {
  gap: 40px;
}

.scl--web-page-career-our-talent-content .scl--web-component-section-description-container{
  margin-top: 20px;
}

.scl--web-page-career-our-talent-content .scl--web-component-section-description-text{
  font-size: 20px;
}

.scl--wpchs-cont-stl-bo-gradient{
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 50;
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/career/css/career.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,gDAAgD;EAChD,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,gDAAgD;EAChD,kDAAkD;EAClD,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mEAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb","sourcesContent":["/* Career Page Styles */\n\n/* Hero Section */\n.scl--web-page-career-hero-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100vh;\n  max-height: 1212px;\n  background: #000000;\n  position: relative;\n  overflow: hidden;\n}\n\n.scl--web-page-career-hero-section .scl--wpchs-cont-stl-bo .scl--web-component-hero-content button{\n  background: transparent;\n  border: 1.5px solid rgba(121, 121, 121, 1)\n}\n\n.scl--web-page-career-hero-section .scl--wpchs-cont-stl-bo .scl--web-component-hero-content button:hover{\n  background: #FFFFFF1A;\n  border: 1px solid white;\n}\n\n.scl--wpchs-cont-stl-bo{\n  position: absolute;\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right);\n  z-index: 51;\n}\n\n.scl--web-page-career-gradient-overlay {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 50%;\n  height: 100%;\n  background: #000000;\n  z-index: 1;\n}\n\n/* Join Us Section */\n.scl--web-page-career-join-us-section {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  min-height: 788px;\n  background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);\n}\n\n.scl--wpcjus-section-job-seek{\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right);\n  display: flex;\n  flex-direction:row;\n}\n\n.scl--web-page-career-join-us-title-side {\n  height: 100%;\n  width: 400px;\n  padding-top: 90px;\n\n}\n\n.scl--web-page-career-join-us-section-title {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 80px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.scl--web-page-career-join-us-section-title .scl--web-component-section-title-text{\n  font-size: var(--font-size-sub-title-xl);\n  line-height: 60px;\n  font-weight: 500;\n}\n\n.scl--web-page-career-view-all-button {\n  min-width: 183px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 20px;\n  gap: 5px;\n  height: 40px;\n  border: 1.5px solid #797979;\n  border-radius: 20px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  margin-top: 15px;\n}\n\n.scl--web-page-career-join-us-job-list-side {\n  height: 100%;\n  width: calc(100% - 400px);\n  padding-top: 175px;\n  padding-left: 90px;\n  padding-bottom: 85px;\n  box-sizing: border-box;\n}\n\n.scl--web-page-career-join-us-job-list-side.active{\n  padding: 0px;\n}\n\n/* Our Talent Section */\n.scl--web-page-career-our-talent-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 80px ;\n  background-color: rgba(0, 0, 0, 1);\n  position: relative;\n  width: 100%;\n}\n\n.scl--web-page-career-our-talent-content {\n  width: 100%;\n  max-width: var(--global-desktop-width-resp);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 60px;\n  padding-left: var(--global-desktop-padding-left);\n  padding-right: var(--global-desktop-padding-right);\n}\n\n.scl--web-page-career-our-talent-section-title {\n  text-align: center;\n  align-items: center;\n}\n\n.scl--web-page-career-our-talent-content .scl--web-component-section-title-container{\n  gap: 0px;\n}\n\n/* Footer Section */\n.scl--web-page-career-footer-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 140px;\n  background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);\n  position: relative;\n  overflow: hidden;\n  min-height: 200px;\n}\n\n.scl--web-page-career-footer-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  z-index: 2;\n}\n\n.scl--web-page-career-icon-bar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n}\n\n.scl--web-page-career-copyright-text {\n  font-family: 'SF Pro', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  text-align: center;\n  color: #8C8C8C;\n  margin: 0;\n}\n\n.scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container{\n  margin-top: 80px;\n}\n\n.scl--web-page-career-our-talent-content .scl--web-component-section-title-text-container h2{\n  font-size: var(--font-size-sub-title-xl);\n  font-weight: 500;\n}\n\n.scl--web-page-career-our-talent-content .scl--web-component-talent-list-container {\n  gap: 40px;\n}\n\n.scl--web-page-career-our-talent-content .scl--web-component-section-description-container{\n  margin-top: 20px;\n}\n\n.scl--web-page-career-our-talent-content .scl--web-component-section-description-text{\n  font-size: 20px;\n}\n\n.scl--wpchs-cont-stl-bo-gradient{\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 50;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
